import cx from 'classnames';
import Link from 'next/link';
import ActionCard from 'plaid-threads/ActionCard';
import React from 'react';
import HideFromUser from 'src/components-v2/Helpers/HideFromUser/HideFromUser';
import Context from '../../../contexts/docs';
import { withTrailingSlash } from '../utilities';
import { isExternalUrl } from 'src/lib/url-helpers';
import styles from './Card.module.scss';

interface Props {
  title: string;
  subtitle?: string;
  link: string;
  linkText: string;
  icon: React.ReactNode;
}

// Custom LinkWrapper that tracks analytics
const AnalyticsLinkWrapper = ({
  href,
  className,
  children,
  dispatch,
  title,
}) => {
  const handleClick = () => {
    dispatch({
      type: 'CARD_CLICKED',
      payload: {
        cardType: 'action',
        title,
        linkPath: href,
      },
    });
  };

  if (isExternalUrl(href)) {
    return (
      <a
        className={className}
        href={href}
        target='_blank'
        rel='noopener'
        onClick={handleClick}
      >
        {children}
      </a>
    );
  } else {
    return (
      <Link href={href} className={className} onClick={handleClick}>
        {children}
      </Link>
    );
  }
};

const Card: React.FC<Props> = ({ title, subtitle, link, linkText, icon }) => {
  const { dispatch } = React.useContext(Context);

  const actionCardProps = {
    className: cx(styles.card, 'hide-for-aeo'),
    title,
    subtitle,
    subtitleClassName: styles.subtitle,
    href: withTrailingSlash(link),
    ctaText: linkText,
    icon,
    component: (props) => (
      <AnalyticsLinkWrapper {...props} dispatch={dispatch} title={title} />
    ),
    componentProps: { href: link },
  };

  return (
    <>
      <ActionCard {...actionCardProps} />
      <HideFromUser>
        <h4>{title}</h4>
        <p>{subtitle}</p>
        <a href={withTrailingSlash(link)}>{linkText}</a>
      </HideFromUser>
    </>
  );
};

Card.displayName = 'Card';

export default Card;
